// extracted by mini-css-extract-plugin
module.exports = {"container":"orders-dashboard-module__container___23b6t","section":"orders-dashboard-module__section___1v0h0"};